import * as React from 'react';
import PencilLineOutlined from './pencil-line-outlined';
import PencilLineFilled from './pencil-line-filled';
import type { IconCombinedProps } from './types';
const PencilLineCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <PencilLineFilled ref={ref} {...rest} />;
  }
  return <PencilLineOutlined ref={ref} {...rest} />;
});
export default PencilLineCombined;